const styles = () => ({
    paper: {
        overflow: 'hidden',
        padding: '30px',
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
